import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import AffiliateContactPopup from '@/components/ui/AffiliateContactPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const AffliateProgram = () => {
  const [openContactModal, setOpenContactModal] = useState(false);

  return (
    <AppLayout
      meta={
        <Meta
          title="Empower Your Audience with Tax Expertise | TaxZerone®"
          description="Recommend the top tax filing service to your audience and earn 20% commission on every referral. Partner with TaxZerone® and start earning today!"
          keywords=""
          canonical="become-a-partner/affliate-program/"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="166"
        />
      }
    >
      <AffiliateContactPopup
        open={openContactModal}
        setOpen={setOpenContactModal}
      />
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Monetize your reach!{' '}
                <span className="highlight-container">
                  <span className="highlight">Be our promoter</span>
                </span>{' '}
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Join our partnership program and turn your reach into income.
                Recommend the simplest, most reliable tax filing platform, and
                earn money for every successful referral. It’s easy, effective,
                and rewarding.
              </Typography>

              <Stack
                direction="row"
                spacing={2}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    Join us today!
                  </Typography>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      zIndex: 99,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                      },
                    }}
                    onClick={() => setOpenContactModal(true)}
                  >
                    Contact Us{' '}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                width: '100%',
              }}
            >
              <picture
                style={{
                  marginTop: 50,
                  display: 'block',
                  lineHeight: 0,
                }}
              >
                <source srcSet="/assets/images/be-our-promoter-img.webp" />
                <source srcSet="/assets/images/be-our-promoter-img.png" />
                <img
                  src="/assets/images/be-our-promoter.png"
                  alt="Monetize your reach! Be our promoter"
                  className="img-responsive-banner"
                  width={880}
                  height={449}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture
                style={{ marginTop: 50, display: 'block', lineHeight: 0 }}
              >
                <source srcSet="/assets/images/be-our-promoter-img.webp" />
                <source srcSet="/assets/images/be-our-promoter-img.png" />
                <img
                  src="/assets/images/be-our-promoter.png"
                  alt="Monetize your reach! Be our promoter"
                  className="img-responsive-banner"
                  width={400}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={2}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Partner with TaxZerone: Boost trust of your follower and Viewer
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  maxWidth: '900px',
                  mx: 'auto',
                  textAlign: 'center',
                  mb: { sm: 8, xs: 4 },
                }}
              >
                TaxZerone’s affiliate partnership is not just the way to earn
                but to build trust among your audience by offering Simple,
                Secure and affordable tax filing solution. With TaxZerone you
                can never go wrong.
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                The partnership we offer for Affiliates
              </Typography>
            </Grid>
          </Grid>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 4, md: 5 },
              borderRadius: '16px',
              border: '2px solid #E2E8F0',
              backgroundColor: '#FFFFFF',
              backgroundImage:
                'repeating-linear-gradient(45deg, #f8fafc, #F8FAFC 10px, #FFFFFF 10px, #FFFFFF 20px)',
              boxShadow: 'inset 0 100px 850px rgba(244, 249, 255, 0.94)',
              maxWidth: 1200,
              mx: 'auto',
              my: 4,
            }}
          >
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: { xs: 3, md: 5 },
                alignItems: 'center',
              }}
            >
              {/* TEXT CONTENT */}
              <Box
                sx={{
                  textAlign: { xs: 'center', md: 'left' },
                  order: { xs: 2, md: 1 },
                }}
              >
                {/* Eyebrow Badge */}
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1.5,
                    py: 0.6,
                    borderRadius: '20px',
                    backgroundColor: 'rgba(33, 62, 153, 0.08)',
                    color: '#213e99',
                    fontSize: 13,
                    fontWeight: 700,
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    mb: 2,
                  }}
                >
                  <CampaignOutlinedIcon
                    sx={{ fontSize: 18, color: '#20a859' }}
                  />
                  Affiliate Program
                </Box>

                {/* Main Title */}
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: '1.75rem', sm: '2rem', lg: '2.25rem' },
                    fontWeight: 800,
                    color: '#0F172A',
                    lineHeight: 1.25,
                    letterSpacing: '-0.02em',
                    mb: 3,
                  }}
                >
                  Give Us a Shout-Out &{' '}
                  <Box
                    component="span"
                    sx={{
                      background:
                        'linear-gradient(135deg, #213e99 0%, #20a859 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    Get Rewarded!
                  </Box>
                </Typography>

                {/* Point 01 */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 2,
                    mb: 2,
                    textAlign: 'left',
                  }}
                >
                  <Box
                    sx={{
                      minWidth: 38,
                      width: 38,
                      height: 38,
                      borderRadius: '10px',
                      backgroundColor: '#F1F5F9',
                      border: '1px solid #E2E8F0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#213e99',
                      flexShrink: 0,
                      mt: 0.3,
                    }}
                  >
                    <ShareOutlinedIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.95rem', md: '1rem' },
                      color: '#475569',
                      lineHeight: 1.6,
                    }}
                  >
                    Recommend our easy-to-use tax filing services to your
                    audience through your video stream, blogs, social media
                    post, or story. Just share the{' '}
                    <Box
                      component="span"
                      sx={{ fontWeight: 600, color: '#0F172A' }}
                    >
                      unique referral link
                    </Box>{' '}
                    we provide you!
                  </Typography>
                </Box>

                {/* Point 02 */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 2,
                    textAlign: 'left',
                  }}
                >
                  <Box
                    sx={{
                      minWidth: 38,
                      width: 38,
                      height: 38,
                      borderRadius: '10px',
                      backgroundColor: '#ECFDF5',
                      border: '1px solid #A7F3D0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#20a859',
                      flexShrink: 0,
                      mt: 0.3,
                    }}
                  >
                    <PaidOutlinedIcon sx={{ fontSize: 20 }} />
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.95rem', md: '1rem' },
                      color: '#475569',
                      lineHeight: 1.6,
                    }}
                  >
                    For every successful referral, you’ll earn a{' '}
                    <Box
                      component="span"
                      sx={{ fontWeight: 600, color: '#0F172A' }}
                    >
                      cash bonus
                    </Box>{' '}
                    — it’s that simple.
                  </Typography>
                </Box>
              </Box>

              {/* IMAGE */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', md: 'flex-end' },
                  alignItems: 'center',
                  order: { xs: 1, md: 2 },
                }}
              >
                <Box
                  component="img"
                  src="/assets/images/give-us-a-reward.svg"
                  alt="Give Us a Shout-Out & Get Rewarded!"
                  loading="lazy"
                  sx={{
                    width: '100%',
                    maxWidth: { xs: 280, sm: 340, md: 400 },
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </Box>
          </Paper>
        </Container>
      </Box>

      <Box
        component="section"
        sx={{
          backgroundColor: '#fff',
          py: { lg: 9, md: 7, sm: 6, xs: 5 },
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            maxWidth: 1200,
            mx: 'auto',
            px: { lg: 3, md: 3, sm: 2, xs: 2 },
          }}
        >
          <Grid size={12}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { sm: 6, xs: 4 },
                textAlign: 'center',
              }}
            >
              How does it work?
            </Typography>
          </Grid>

          <Box
            sx={{
              display: {
                lg: 'grid',
                md: 'none',
                sm: 'none',
                xs: 'none',
              },
              gridTemplateColumns: '1fr 105px 1fr',
              rowGap: 0,
              alignItems: 'center',
            }}
          >
            {/* ================= STEP 01 ================= */}
            <Paper
              elevation={0}
              sx={{
                gridColumn: '1',
                gridRow: '1',
                minHeight: 155,
                p: 2.5,
                display: 'flex',
                alignItems: 'center',
                gap: 2.5,
                borderRadius: '18px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                backgroundColor: '#fff',
                boxShadow: '8px 0px 26px rgba(91,98,117,.13)',
                position: 'relative',
                zIndex: 1,
              }}
            >
              {/* Step Number */}
              <Box
                sx={{
                  position: 'absolute',
                  top: -15,
                  left: -15,
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#1da94a',
                  color: '#fff',
                  fontSize: 17,
                  fontWeight: 700,
                  border: '4px solid #fff',
                  boxShadow: '0 4px 14px rgba(72, 49, 220, 0.22)',
                }}
              >
                01
              </Box>

              {/* Icon */}
              <Box
                sx={{
                  minWidth: 82,
                  width: 82,
                  height: 82,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background:
                    'linear-gradient(135deg, #f1f1f1 0%, #f0f0f0 100%)',
                  color: '#213e99',
                }}
              >
                <ContactSupportOutlinedIcon sx={{ fontSize: 38 }} />
              </Box>

              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#101b45',
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18 },
                    lineHeight: 1.3,
                  }}
                >
                  Click on ‘Contact Us’
                </Typography>
              </Box>
            </Paper>

            {/* Arrow 01 → 02 */}
            <Box
              sx={{
                gridColumn: '2',
                gridRow: '1',
                height: 85,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                width="105"
                height="85"
                viewBox="0 0 120 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 20 C45 20 50 75 105 75"
                  stroke="#213e99"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <path
                  d="M92 62 L105 75 L92 88"
                  stroke="#213e99"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>

            {/* ================= STEP 02 ================= */}
            <Paper
              elevation={0}
              sx={{
                gridColumn: '3',
                gridRow: '1',
                minHeight: 155,
                p: 2.5,
                display: 'flex',
                alignItems: 'center',
                gap: 2.5,
                borderRadius: '18px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                backgroundColor: '#fff',
                boxShadow: '8px 0px 26px rgba(91,98,117,.13)',
                position: 'relative',
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: -15,
                  left: -15,
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#1da94a',
                  color: '#fff',
                  fontSize: 17,
                  fontWeight: 700,
                  border: '4px solid #fff',
                  boxShadow: '0 4px 14px rgba(72, 49, 220, 0.22)',
                }}
              >
                02
              </Box>

              <Box
                sx={{
                  minWidth: 82,
                  width: 82,
                  height: 82,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background:
                    'linear-gradient(135deg, #f1f1f1 0%, #f0f0f0 100%)',
                  color: '#213e99',
                }}
              >
                <LinkOutlinedIcon sx={{ fontSize: 38 }} />
              </Box>

              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#101b45',
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18 },
                    lineHeight: 1.3,
                  }}
                >
                  Get your Unique Code and Web Link
                </Typography>
              </Box>
            </Paper>

            {/* ================= CONNECTOR 02 → 03 ================= */}
            <Box
              sx={{
                gridColumn: '2',
                gridRow: '2',
                height: 90,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                width="105"
                height="90"
                viewBox="0 0 120 110"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M110 20 C70 20 65 85 15 85"
                  stroke="#213e99"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <path
                  d="M28 72 L15 85 L28 98"
                  stroke="#213e99"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>

            {/* ================= STEP 03 ================= */}
            <Paper
              elevation={0}
              sx={{
                gridColumn: '1',
                gridRow: '3',
                minHeight: 155,
                p: 2.5,
                display: 'flex',
                alignItems: 'center',
                gap: 2.5,
                borderRadius: '18px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                backgroundColor: '#fff',
                boxShadow: '8px 0px 26px rgba(91,98,117,.13)',
                position: 'relative',
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: -15,
                  left: -15,
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#1da94a',
                  color: '#fff',
                  fontSize: 17,
                  fontWeight: 700,
                  border: '4px solid #fff',
                  boxShadow: '0 4px 14px rgba(72, 49, 220, 0.22)',
                }}
              >
                03
              </Box>

              <Box
                sx={{
                  minWidth: 82,
                  width: 82,
                  height: 82,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background:
                    'linear-gradient(135deg, #f1f1f1 0%, #f0f0f0 100%)',
                  color: '#213e99',
                }}
              >
                <CampaignOutlinedIcon sx={{ fontSize: 38 }} />
              </Box>

              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#101b45',
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18 },
                    lineHeight: 1.3,
                  }}
                >
                  Promote us using the unique code and web link
                </Typography>
              </Box>
            </Paper>

            {/* ================= CONNECTOR 03 → 04 ================= */}
            <Box
              sx={{
                gridColumn: '2',
                gridRow: '3',
                height: 85,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg
                width="105"
                height="85"
                viewBox="0 0 120 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 20 C45 20 50 75 105 75"
                  stroke="#213e99"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
                <path
                  d="M92 62 L105 75 L92 88"
                  stroke="#213e99"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Box>

            {/* ================= STEP 04 ================= */}
            <Paper
              elevation={0}
              sx={{
                gridColumn: '3',
                gridRow: '3',
                minHeight: 155,
                p: 2.5,
                display: 'flex',
                alignItems: 'center',
                gap: 2.5,
                borderRadius: '18px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                background: 'linear-gradient(135deg, #ffffff 0%, #f5faff 100%)',
                boxShadow: '8px 0px 26px rgba(91,98,117,.13)',
                position: 'relative',
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: -15,
                  left: -15,
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#1da94a',
                  color: '#fff',
                  fontSize: 17,
                  fontWeight: 700,
                  border: '4px solid #fff',
                  boxShadow: '0 4px 14px rgba(72, 49, 220, 0.22)',
                }}
              >
                04
              </Box>

              <Box
                sx={{
                  minWidth: 82,
                  width: 82,
                  height: 82,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background:
                    'linear-gradient(135deg, #f1f1f1 0%, #f0f0f0 100%)',
                  color: '#213e99',
                }}
              >
                <PaymentsOutlinedIcon sx={{ fontSize: 38 }} />
              </Box>

              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#101b45',
                    fontWeight: 600,
                    fontSize: { lg: 20, md: 18 },
                    lineHeight: 1.3,
                  }}
                >
                  Earn{' '}
                  <Box component="span" sx={{ color: '#4d2de0' }}>
                    20%
                  </Box>{' '}
                  commission on every successful Filing
                </Typography>
              </Box>
            </Paper>
          </Box>

          {/* TABLET / MOBILE */}

          <Box
            sx={{
              display: {
                lg: 'none',
                md: 'flex',
                sm: 'flex',
                xs: 'flex',
              },
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* STEP 01 */}
            <Paper
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: 700,
                p: { md: 3, sm: 2.5, xs: 2 },
                display: 'flex',
                alignItems: 'center',
                gap: { md: 3, sm: 2.5, xs: 2 },
                borderRadius: '20px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                boxShadow: '0 10px 30px rgba(54, 50, 74, 0.07)',
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  width: { md: 90, sm: 80, xs: 70 },
                  height: { md: 90, sm: 80, xs: 70 },
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#f0efff',
                  color: '#213e99',
                }}
              >
                <ContactSupportOutlinedIcon
                  sx={{
                    fontSize: { md: 44, sm: 38, xs: 32 },
                  }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: '#101b45',
                    fontWeight: 700,
                    fontSize: { md: 18, sm: 17, xs: 15 },
                    mb: 0.75,
                  }}
                >
                  01. Click on ‘Contact Us’
                </Typography>

                <Typography
                  sx={{
                    color: '#52617d',
                    fontSize: { md: 16, sm: 15, xs: 14 },
                    lineHeight: 1.55,
                  }}
                >
                  Visit our website and click on the ‘Contact Us’ button to get
                  started.
                </Typography>
              </Box>
            </Paper>

            {/* Vertical Arrow */}
            <Box
              sx={{
                height: 45,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#5337e8',
                  fontSize: 30,
                  lineHeight: 1,
                }}
              >
                ↓
              </Typography>
            </Box>

            {/* STEP 02 */}
            <Paper
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: 700,
                p: { md: 3, sm: 2.5, xs: 2 },
                display: 'flex',
                alignItems: 'center',
                gap: { md: 3, sm: 2.5, xs: 2 },
                borderRadius: '20px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                boxShadow: '0 10px 30px rgba(54, 50, 74, 0.07)',
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  width: { md: 90, sm: 80, xs: 70 },
                  height: { md: 90, sm: 80, xs: 70 },
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#f0efff',
                  color: '#213e99',
                }}
              >
                <LinkOutlinedIcon
                  sx={{
                    fontSize: { md: 44, sm: 38, xs: 32 },
                  }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: '#101b45',
                    fontWeight: 700,
                    fontSize: { md: 18, sm: 17, xs: 15 },
                    mb: 0.75,
                  }}
                >
                  02. Get your Unique Code and Web Link
                </Typography>

                <Typography
                  sx={{
                    color: '#52617d',
                    fontSize: { md: 16, sm: 15, xs: 14 },
                    lineHeight: 1.55,
                  }}
                >
                  Receive your exclusive referral code and personalized web link
                  from our team.
                </Typography>
              </Box>
            </Paper>

            {/* Vertical Arrow */}
            <Box
              sx={{
                height: 45,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#5337e8',
                  fontSize: 30,
                  lineHeight: 1,
                }}
              >
                ↓
              </Typography>
            </Box>

            {/* STEP 03 */}
            <Paper
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: 700,
                p: { md: 3, sm: 2.5, xs: 2 },
                display: 'flex',
                alignItems: 'center',
                gap: { md: 3, sm: 2.5, xs: 2 },
                borderRadius: '20px',
                border: '1px solid rgba(170, 170, 170, 0.2)',
                boxShadow: '0 10px 30px rgba(54, 50, 74, 0.07)',
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  width: { md: 90, sm: 80, xs: 70 },
                  height: { md: 90, sm: 80, xs: 70 },
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#f0efff',
                  color: '#213e99',
                }}
              >
                <CampaignOutlinedIcon
                  sx={{
                    fontSize: { md: 44, sm: 38, xs: 32 },
                  }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: '#101b45',
                    fontWeight: 700,
                    fontSize: { md: 18, sm: 17, xs: 15 },
                    mb: 0.75,
                  }}
                >
                  03. Promote us using the unique code and web link
                </Typography>

                <Typography
                  sx={{
                    color: '#52617d',
                    fontSize: { md: 16, sm: 15, xs: 14 },
                    lineHeight: 1.55,
                  }}
                >
                  Share your code and link with your clients, friends, and
                  community.
                </Typography>
              </Box>
            </Paper>

            {/* Vertical Arrow */}
            <Box
              sx={{
                height: 45,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  color: '#5337e8',
                  fontSize: 30,
                  lineHeight: 1,
                }}
              >
                ↓
              </Typography>
            </Box>

            {/* STEP 04 */}
            <Paper
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: 700,
                p: { md: 3, sm: 2.5, xs: 2 },
                display: 'flex',
                alignItems: 'center',
                gap: { md: 3, sm: 2.5, xs: 2 },
                borderRadius: '20px',
                border: '1.5px solid #62d8ae',
                background: 'linear-gradient(135deg, #ffffff 0%, #f5fffb 100%)',
                boxShadow: '0 12px 35px rgba(36, 194, 142, 0.10)',
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  width: { md: 90, sm: 80, xs: 70 },
                  height: { md: 90, sm: 80, xs: 70 },
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: '#effdf7',
                  color: '#213e99',
                }}
              >
                <PaymentsOutlinedIcon
                  sx={{
                    fontSize: { md: 44, sm: 38, xs: 32 },
                  }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: '#101b45',
                    fontWeight: 700,
                    fontSize: { md: 18, sm: 17, xs: 15 },
                    mb: 0.75,
                  }}
                >
                  04. Earn{' '}
                  <Box
                    component="span"
                    sx={{
                      color: '#4d2de0',
                    }}
                  >
                    20%
                  </Box>{' '}
                  commission on every successful Filing
                </Typography>

                <Typography
                  sx={{
                    color: '#52617d',
                    fontSize: { md: 16, sm: 15, xs: 14 },
                    lineHeight: 1.55,
                  }}
                >
                  Get rewarded with 20% commission for every successful filing
                  through your link.
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { xs: 1, sm: 3 },
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 3,
              textAlign: 'center',
              lineHeight: 1.3,
              mt: 5,
            }}
          >
            Benefits of partnering with TaxZerone
          </Typography>

          <Grid
            container
            spacing={2}
            m={2}
            pb={2}
            className="MuiGrid-root-width"
            sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
            component="ul"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: { xs: 2, sm: 5 },
                  pb: { xs: 2, sm: 5 },
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#1da94a',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 50, height: 56 }}>
                    <source srcSet="/assets/images/irs-file-icon.webp" />
                    <source srcSet="/assets/images/irs-file-icon.png" />
                    <img
                      src="/assets/images/irs-file-icon.png"
                      alt="Build Trust Grow Your Reach."
                      loading="lazy"
                      width={50}
                      height={56}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Build Trust. Grow Your Reach.
                </Typography>
                <Typography variant="body1">
                  When you recommend an{' '}
                  <span style={{ fontWeight: 700 }}>
                    IRS-authorized filing solution
                  </span>
                  , your audience knows they’re in safe hands. More trust means
                  stronger engagement, and greater reach.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: { xs: 2, sm: 5 },
                  pb: { xs: 2, sm: 5 },
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#1da94a',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 62, height: 54 }}>
                    <source srcSet="/assets/images/irs-white-icon.webp" />
                    <source srcSet="/assets/images/irs-white-icon.png" />
                    <img
                      src="/assets/images/irs-white-icon.png"
                      alt="Track Your Success in Real Time"
                      loading="lazy"
                      width={62}
                      height={54}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Track Your Success in Real Time
                </Typography>
                <Typography variant="body1">
                  Stay on top of your performance with a{' '}
                  <span style={{ fontWeight: 700 }}>
                    dedicated affiliate dashboard
                  </span>
                  . Monitor clicks, referrals, and earnings, all in one place.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: { xs: 2, sm: 5 },
                  pb: { xs: 2, sm: 5 },
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 10,
                  height: '100%',
                  boxShadow: '10px 0px 30px rgba(91,98,117,.15)',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#1da94a',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 62, height: 54 }}>
                    <source srcSet="/assets/images/secure-white-icon.webp" />
                    <source srcSet="/assets/images/secure-white-icon.png" />
                    <img
                      src="/assets/images/secure-white-icon.png"
                      alt="One Platform 50+ IRS Forms."
                      loading="lazy"
                      width={62}
                      height={54}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  One Platform. 50+ IRS Forms.
                </Typography>
                <Typography variant="body1">
                  From{' '}
                  <span style={{ fontWeight: 700 }}>
                    payroll to business taxes
                  </span>
                  , your audience can file over 50 types of IRS forms using our
                  simple, secure, and comprehensive platform.
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          <Button
            variant="contained"
            sx={{
              mt: 4,
              mb: 4,
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            className="btn-primary"
            onClick={() => setOpenContactModal(true)}
          >
            Join Us Today
          </Button>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Recommend. Reach. Reward
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mb: 2,
            mx: 'auto',
            maxWidth: { sm: '50%', xs: 'auto' },
          }}
        >
          <span style={{ fontWeight: 700 }}>
            Spread the word about TaxZerone’s magical way of simplifying tax
            filing!{' '}
          </span>
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mb: 2,
            mx: 'auto',
            maxWidth: { sm: '50%', xs: 'auto' },
          }}
        >
          Empower your audience with a platform they can trust. And the best
          part? You earn rewards for every tax filer you bring in!
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            onClick={() => setOpenContactModal(true)}
          >
            Let's Partner Up
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default AffliateProgram;
